var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"disabled":_vm.disabled,"item-text":_vm.itemText,"item-value":_vm.itemValue,"items":_vm.items,"label":_vm.label,"clearable":"","dense":"","outlined":"","hide-details":""},model:{value:(_vm.innerModel),callback:function ($$v) {_vm.innerModel=$$v},expression:"innerModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }